import {createAction, props} from '@ngrx/store';
import {AvailablePersistentAddresses} from '../../../services/api/account/persistent-addresses/persistent-address.model';
import {RegionCode} from '../../../services/api/account/regions/region.model';

const category = '[OrganizationPersistentAddresses]';

export const loadOrganizationPersistentAddresses = createAction(
  `${category} Load Organization Persistent Addresses`,
  props<{ region: RegionCode }>()
);

export const loadOrganizationPersistentAddressesSuccess = createAction(
  `${category} Load Organization Persistent Addresses Success`,
  props<{ data: AvailablePersistentAddresses }>()
);

export const loadOrganizationPersistentAddressesFailure = createAction(
  `${category} Load Organization Persistent Addresses Failure`,
  props<{ error: any }>()
);

export const clearOrganizationPersistentAddressesState = createAction(
  `${category} Clear Organization Persistent Addresses State`
);
